
import React from "react";
import "./AadharFulfill.css";

const AadharFulfill = ({ autofillData = {}, onBack, onNext }) => {

  return (
    <div className="aadhaar-page-wrapper">
      <div className="aadhaar-card">
        <div className="aadhaar-icon">5f</div>
        <h3 className="aadhaar-title">Aadhaar Verified Successfully</h3>
        <p className="aadhaar-subtitle">Your verification process is complete.</p>
        <div className="aadhaar-details">
          <div><b>Name:</b> {autofillData.name || "-"}</div>
          <div><b>Gender:</b> {autofillData.gender || "-"}</div>
          <div><b>Date of Birth:</b> {autofillData.dob || autofillData.dateOfBirth || "-"}</div>
          <div><b>Mobile:</b> {autofillData.mobile || autofillData.mobile || "-"}</div>
          <div><b>Address:</b> {autofillData.address || "-"}</div>
          <div><b>District:</b> {autofillData.district || "-"}</div>
          <div><b>State:</b> {autofillData.state || "-"}</div>
          <div><b>Pincode:</b> {autofillData.pincode || "-"}</div>
        </div>
        <div style={{ marginTop: 16 }}>
          <button onClick={onBack}>Back</button>
          <button onClick={onNext} style={{ marginLeft: 8 }}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default AadharFulfill;
